export default __webpack_public_path__ + "static/media/modal-close.f594c09b.svg";